/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSendLuckyGift.vue?vue&type=template&id=1a605e60&scoped=true"
import script from "./popSendLuckyGift.vue?vue&type=script&lang=js"
export * from "./popSendLuckyGift.vue?vue&type=script&lang=js"
import style0 from "./popSendLuckyGift.vue?vue&type=style&index=0&id=1a605e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a605e60",
  null
  
)

export default component.exports